

const DRAW_VISITS = 'webservice/draw-visits';
const GET_AVAILABLE_FIELDWORKERS = 'common/get-available-fieldworkers-dropdown';
const GET_CONTRACTOR_SUBWORKERS = 'webservice/contractor/subworker/list';
const sendReminderBookings_url = 'sendReminderBookings';

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

module.exports = {
    drawVisits: function (params) {
        return window.axios.get(DRAW_VISITS, {params: params});
    },
    getContractors: function(data){
        let formData = new FormData($('#fmEdit').get()[0]);
        buildFormData(formData,data);
        return window.axios.post(GET_AVAILABLE_FIELDWORKERS,formData,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    },
    getSubWorkers: function (params){
        return window.axios.get(GET_CONTRACTOR_SUBWORKERS, {params: params});
    }
    ,   sendReminderBookings: function (params){
        return window.axios.get(sendReminderBookings_url, {params: params});
    }
};  
